import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Cross from '../../imgs/cross.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from '../../styles/SideNav.module.scss';
import Logo from '../../imgs/logo.svg';
import Arrow from '../../imgs/arrow.svg';
import { removeSpacesFromId } from '../utils/keHelper';
import useWindowDimensions from '../utils/ScreenSize';
import { Button } from 'react-bootstrap';
import { redirectUrl } from '../config/endPoints';

const SideNav = ({
  blogs,
  currentSlug,
  openSideNav,
  setOpenSideNav,
  haveToken,
  setShowLogin,
  setShowSignup,
}) => {
  const { width } = useWindowDimensions();
  // const [openSideNav, setOpen] = useState(true);
  console.log('side nav', openSideNav);

  const handleArrowClick = (e) => {
    e.preventDefault();
    setOpenSideNav(!openSideNav);
  };

  return (
      <div
        className={`sidenav ${styles.sideNav}`}
        style={
          width > 800
            ? { width: '260px', zIndex: 9 }
            : { width: openSideNav ? '80%' : '0px', boxShadow: '0px 0px 15px 3px #80808073' }
        }
      >
        {width < 800 ? (
          <div>
            <div className={styles.sideNavHeader}>
              <Link href="/" title="Home Page" passHref>
                <div className="logoBox">
                  <Image src={Logo} alt="Mendelgen Logo" />
                </div>
              </Link>
              <div className={styles.sideNavButton} onClick={() => setOpenSideNav(false)}>
                <Image src={Cross} alt="Close Menu" className="cross" width={50} />
              </div>
            </div>
            <div className={styles.sideNavMenu}>
              {haveToken ? (
                <Button
                  id="signup"
                  className="sign"
                  style={{ display: 'unset', width: '80%' }}
                  onClick={() => {
                    document.location.href = redirectUrl;
                  }}
                >
                  <span className="navLink">Go To App</span>
                </Button>
              ) : (
                <>
                  <button
                    id="signin"
                    style={{ display: 'unset' }}
                    className={styles.sideNavMenuItem}
                    onClick={() => setShowLogin(true)}
                  >
                    <div className="mbNavLink">
                      <span className="navLink">Sign In</span>
                    </div>
                  </button>
                  <Button
                    id="signup"
                    className="sign"
                    style={{ display: 'unset', width: '80%' }}
                    onClick={() => {
                      setShowSignup(true);
                    }}
                  >
                    <span className="navLink">Sign Up</span>
                  </Button>
                </>
              )}
            </div>
          </div>
        ) : (
          <div style={{ marginTop: '80px' }}></div>
        )}

        <div>
          {blogs.map((blog, i) => {
            const { slug, metaTitle, subheadings } = blog;
            return (
              <div key={i} onClick={width < 800 ? () => setOpenSideNav(false) : null}>
                <Link passHref href={`/${slug}`}>
                  <a className={`sectionTitle ${currentSlug === slug && 'selected'}`}>
                    {metaTitle}
                  </a>
                </Link>
                {subheadings &&
                  subheadings.headings.map((heading, j) => (
                    <Link
                      key={`${i}${j}`}
                      passHref
                      href={`/${slug}/#${removeSpacesFromId(heading)}`}
                    >
                      {heading}
                    </Link>
                  ))}
              </div>
            );
          })}
        </div>
      </div>
  );
};

export default SideNav;
